<mbs-modal [title]="'shared:modals.addDestinationBucket.detectIssues' | i18next">
  <ng-container modal-body>
    <div>
      {{ 'shared:modals.immutability.objectLockChangesWillBeSaved' | i18next }}
    </div>

    <div class="mb-3">
      {{ 'shared:modals.immutability.toAvoidErrors' | i18next }}
    </div>

    <mbs-checkbox
      [label]="'shared:modals.immutability.objectLockChangesConfirmation' | i18next"
      [formControl]="confirmed"></mbs-checkbox>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [disabled]="!confirmed.value"
      (click)="confirmClickHandler()"
      >{{ 'shared:buttons.confirm' | i18next: { format: 'title' } }}</mbs-button
    >
    <mbs-button
      type="secondary"
      (click)="cancelClickHandler()"
      >{{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}</mbs-button
    >
  </ng-container>
</mbs-modal>
